import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MembersSearchRoutingModule } from './members-search-routing.module';
import { BootstrapMembersSearchComponent } from './components/bootstrap-members-search/bootstrap-members-search.component';
import { TableMembersSearchComponent } from './components/table-members-search/table-members-search.component';
import { MembersFiltersComponent } from './components/members-filters-component/members-filters-component.component';
import { MembersSearchFiltersService } from './services/members-search-filters.service';
import { CoreModule } from 'world-archery-lib';
import { CommonPageComponentsModule } from '../../../common-page-components/common-page-components.module';
import { ServicesModule } from '../../../library/components/services/services.module';
import { ContinentalFederationLinkComponent } from './components/continental-federation-link/continental-federation-link.component';

@NgModule({
  declarations: [
    BootstrapMembersSearchComponent,
    TableMembersSearchComponent,
    MembersFiltersComponent,
    ContinentalFederationLinkComponent],
  imports: [
    CommonModule,
    MembersSearchRoutingModule,
    CoreModule,
    CommonPageComponentsModule,
    ServicesModule
  ],
  providers: [
    MembersSearchFiltersService
  ]
})
export class MembersSearchModule { }
